<template>
  <div>
    <div
      v-if="loadTransactionDetails"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting transaction details details ready...</h3>
        </div>
      </div>
    </div>

    <div v-if="showQueryModal">
      <CModal v-show="showQueryModal" @close="closeQueryModal" modalIsLarge>
        <template v-slot:title> <h5>Transaction Query</h5> </template>

        <template v-slot:body>
            <div v-if="queryData !== null">
              <div>{{ queryData.message }}</div>
            </div>
        </template>
      </CModal>
    </div>
    <modal
      v-show="isFlagModalVisible"
      @close="closeFlagModal"
      modalIsLarge
      footer
    >
      <template v-slot:title>
        <h5>Transaction Flag Trails</h5>
      </template>
      <template v-slot:body>
        <div v-if="trails.length > 0" class="my-2 scroll-h">
          <div
            v-for="(item, index) in trails"
            :key="index"
            class="shadow-sm rounded-2 max-width my-2"
          >
            <p class="m-0 fw-bold text-dark">
              {{ item.user.first_name }} {{ item.user.last_name }}
            </p>
            <p class="m-0">{{ item.message }}</p>
            <p class="m-0 text-info text-italic">{{ item.date | date }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-9">
            <div class="form-group">
              <label for="">Message</label>
              <textarea
                name=""
                id=""
                cols="30"
                rows="4"
                class="form-control"
                style="resize: none"
                v-model="flagMessage"
              ></textarea>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label for="">Status</label>
              <select class="form-control" v-model="flagStatus">
                <option value="" disabled selected>Please Select Status</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="button"
          @click="postFlagTrail"
          :disabled="flagLoading || !formIsValid"
        >
          <span class="custom-loader" v-if="flagLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait...</span
            >
          </span>
          <span v-else>
            Proceed
          </span>
        </button>
        <button type="button" class="btn btn-secondary" @click="closeFlagModal">
          Close
        </button>
      </template>
    </modal>

    <modal v-show="showUpdateModal" @close="closeModal" modalIsLarge footer>
      <template v-slot:title> <h5>Update Transaction Status</h5> </template>
      <template v-slot:body>
        <div class=" form-group">
          <label>Status</label>
          <select v-model="statusQuery" class="form-control">
            <option value="" selected disabled>Please Select Status </option>
            <option value="pending">Pending</option>
            <option value="failed">Failed</option>
            <option value="successful">Successful</option>
            <option value="reversed">Reversed</option>
          </select>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="button"
          @click.prevent="updatePaymentStatus"
          :disabled="statusLoading || statusQuery === ''"
        >
          <span class="custom-loader" v-if="statusLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Please wait...</span
            >
          </span>
          <span v-else>
            Update Status
          </span>
        </button>
        <button @click="closeModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </modal>

    <div class="order--main-content" v-if="transactionDetails">
      <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </div>

      <h1 class="mt-2 mb-3 font-regular">
        Payment&nbsp;&nbsp;<span style="color: #32417E;">{{ slug }}</span> from
        {{ transactionDetails.description }}
      </h1>
      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Payment Details
              </a>
            </li>
            <!-- <li
              class="nav-item"
              v-if="transactionDetails.provider_entries !== null"
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Payment Entries
              </a>
            </li> -->
          </CScrollbar>
        </div>
      </div>

      <div class="row" v-if="activetab === 1">
        <div class="col-md-6 mb-3">
          <!-- Transaction Summary -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Payment Details</h3>
            </div>
            <div class="card-content" v-if="transactionDetails">
              <div class="card-body">
                <div
                  class="transaction-details"
                  v-for="(value, name, index) in transactionDetails.readable"
                  :key="index"
                >
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        {{ name }}
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6 v-html="value" class="text-blue fw-400"></h6>
                    </div>
                  </div>
                </div>
                <div class="transaction-details">
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Source of Transaction
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6 class="text-blue fw-400">
                        {{
                          transactionDetails.terminal_id
                            ? "Terminal"
                            : "Account"
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div
                  class="transaction-details"
                  v-if="transactionDetails.balance_before !== null"
                >
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Balance Before
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6 class="text-blue fw-400">
                        {{ transactionDetails.balance_before }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div
                  class="transaction-details"
                  v-if="transactionDetails.balance_after !== null"
                >
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Balance After
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6 class="text-blue fw-400">
                        {{ transactionDetails.balance_after }}
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="transaction-details">
                  <div
                    class="row align-items-center justify-content-between mt-1"
                    v-if="transactionDetails.user"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Account Name
                      </h5>
                    </div>
                    <div class="col-auto">
                      <router-link
                        v-if="permissions.includes('view-customer')"
                        :event="
                          permissions.includes('view-customer') ? 'click' : ''
                        "
                        :to="{
                          name: 'CustomerComponent',
                          params: { slug: transactionDetails.user.id }
                        }"
                      >
                        <h6 class="text-blue fw-400">
                          {{
                            transactionDetails.user
                              ? transactionDetails.user.last_name +
                                " " +
                                transactionDetails.user.first_name
                              : ""
                          }}
                        </h6>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <!-- Transaction Summary -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Actions</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <button
                  class="btn btn-primary d-block my-2"
                  @click="openModal"
                  v-if="
                    permissions.includes('update-payment-status')
                  "
                >
                  Update Transaction Status
                </button>
                <!-- <button
                  class="btn btn-danger d-block my-2 btn-flickr"
                  v-if="
                    permissions.includes('reverse-payment') &&
                      transactionDetails.status === 'pending'
                  "
                  @click.prevent="reversePayment"
                >
                  <span class="custom-loader" v-if="reverseLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>Reverse Transaction</span>
                </button> -->
                <button
                  class="btn btn-danger d-block my-2 btn-flickr"
                  v-if="
                    permissions.includes('check-transaction-status')
                  "
                  @click.prevent="checkPaymentStatus"
                >
                  <span class="custom-loader" v-if="reverseLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>Check Transaction Status</span>
                </button>
                <button
                  class="btn btn-danger d-block my-2 btn-flickr"
                  @click.prevent="generateReceipt"
                >
                  <span class="custom-loader" v-if="reverseLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>Generate Receipt</span>
                </button>
                <!-- <button
                  class="mt-1 btn btn-warning d-block mb-1"
                  v-if="
                    permissions.includes('retrigger-payment') &&
                      transactionDetails.status === 'pending'
                  "
                  @click="retriggerPayment"
                  :disabled="triggerLoading"
                >
                  <span class="custom-loader" v-if="triggerLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>
                    Re-Trigger Transaction
                  </span>
                </button> -->
                <button
                  class="btn my-2 d-block btn-facebook"
                  v-if="
                    permissions.includes('credit-cashout') &&
                      transactionDetails.category === 'cashout' &&
                      transactionDetails.status === 'pending'
                  "
                  @click.prevent="creditCashout"
                  :disabled="creditCashoutLoading"
                >
                  <span class="custom-loader" v-if="creditCashoutLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Please wait...</span
                    >
                  </span>
                  <span v-else>
                    Credit Cashout
                  </span>
                </button>
                <button
                  class="btn btn-danger"
                  @click="openFlagModal"
                  v-if="
                    permissions.includes('flag-payment') &&
                      transactionDetails.status !== 'successful'
                  "
                >
                  Flag Transaction
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">External Transactions</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div v-if="external_transactions">
                  <CDataTable
                    :items="external_transactions"
                    :fields="entry_fields"
                    :items-per-page="small ? 10 : 5"
                    pagination
                    sorter
                    tableFilter
                  >
                    <template #action="{item}">
                      <td class="table--action-mobile row">
                        <button
                          class="button btn-primary"
                          @click="queryPayment(item.internal_reference)"
                          :disabled="
                            queryLoading && item.internal_reference === ref_diff
                          "
                        >
                          <span
                            v-if="
                              queryLoading &&
                                item.internal_reference === ref_diff
                            "
                          >
                            <loader-icon
                              size="1.5x"
                              class="custom-class"
                            ></loader-icon>
                            <span>
                              Please Wait
                            </span>
                          </span>
                          <span v-else>
                            <span> Query</span>
                          </span>
                        </button>
                      </td>
                    </template>
                  </CDataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Payment Entries -->
      <div class="row" v-if="activetab === 2">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import CScrollbar from "@/components/CScrollbar";
import CPagination from "@/components/CPagination";
import CDataTable from "@/components/CDataTable";
import CModal from "@/components/CModal";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const entry_fields = [
  "provider",
  "internal_reference",
  "status",
  "type",
  "response_code",
  "response_body",
  "created_at",
  "action"
];

export default {
  props: {
    slug: {
      type: [String],
      required: true
    }
  },
  components: {
    CScrollbar,
    CDataTable,
    CModal
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    formIsValid() {
      return this.flagStatus !== "" && this.flagMessage !== "";
    }
  },
  data() {
    return {
      triggerLoading: false,
      entry_fields,
      updateStatus: false,
      transactionDetails: null,
      loadTransactionDetails: false,
      activetab: 1,
      small: false,
      external_transactions: null,
      queryLoading: false,
      queryData: null,
      showQueryModal: false,
      ref_diff: "",
      showUpdateModal: false,
      statusQuery: "",
      statusLoading: false,
      reverseLoading: false,
      creditCashoutLoading: false,
      isFlagModalVisible: false,
      trails: [],
      flagStatus: "",
      flagMessage: "",
      flagLoading: false
    };
  },
  methods: {
    openFlagModal() {
      this.isFlagModalVisible = true;
    },
    closeFlagModal() {
      this.isFlagModalVisible = false;
      this.flagMessage = "";
      this.flagStatus = "";
    },
    async postFlagTrail() {
      let data = {
        message: this.flagMessage,
        status: this.flagStatus,
        transaction_id: this.transactionDetails.id
      };
      this.flagLoading = true;
      try {
        let response = await ApiService.post("payment/flag-payment", data);

        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        // this.closeFlagModal();

        this.flagLoading = false;
        this.flagStatus = "";
        this.flagMessage = "";
        this.getTrails(this.transactionDetails.id);
      } catch (error) {
        this.closeFlagModal();
        this.flagLoading = false;

        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getTrails(id) {
      try {
        const response = await ApiService.get(`payment/flags/${id}`);

        this.trails = response.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async openModal() {
      console.log("hello");
      this.showUpdateModal = true;
    },
    async closeModal() {
      this.showUpdateModal = false;
      this.statusQuery = "";
    },
    async closeQueryModal() {
      this.showQueryModal = false;
      this.queryData = null;
    },
    async queryPayment(ref) {
      this.ref_diff = ref;
      this.queryLoading = true;
      try {
        const response = await ApiService.get(`payment/query/${ref}`);
        this.queryLoading = false;
        console.log(response.data.data);
        this.queryData = response.data.data;
        this.showQueryModal = true;
      } catch (error) {
        this.queryLoading = false;
        console.log(error.response);
        this.updateCustomerLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getTransactionDetails() {
      this.loadTransactionDetails = true;
      try {
        const response = await ApiService.get(`payment/view/${this.slug}`);
        this.loadTransactionDetails = false;
        this.transactionDetails = response.data.data;
        if (this.can("flag-payment")) {
          this.getTrails(response.data.data.id);
        }
        this.statusQuery = this.transactionDetails.status;
        console.log(this.transactionDetails);
        this.external_transactions = response.data.data.external_transactions;
      } catch (error) {
        this.loadTransactionDetails = false;
        console.log(error.response);
      }
    },
    async creditCashOut() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to perform a cashout on this transaction  ${this.transactionDetails.description}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.creditFunction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
          }
        });
    },
    async creditFunction() {
      this.creditCashoutLoading = true;
      try {
        const response = await ApiService.get(
          `payment/credit-cashout/${this.transactionDetails.transaction_reference}`
        );

        this.creditCashoutLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getTransactionDetails();
      } catch (error) {
        this.creditCashoutLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async reversePayment() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to Reverse the transaction  ${this.transactionDetails.description}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.reverseFunction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
          }
        });
    },
    async checkPaymentStatus() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to check the transaction sttus of  ${this.transactionDetails.description}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.checkPaymentStatusFunction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
          }
        });
    },
    async generateReceipt() {
      try {
        const response = await ApiService.get(
          `payment/receipt/${this.transactionDetails.transaction_reference}`
        );

        this.reverseLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        //open new tab
        window.open(response.data.data, "_blank");
      } catch (error) {
        this.reverseLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async checkPaymentStatusFunction() {
      this.reverseLoading = true;
      try {
        const response = await ApiService.get(
          `payment/check-transaction-status/${this.transactionDetails.transaction_reference}`
        );

        this.reverseLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getTransactionDetails();
      } catch (error) {
        this.reverseLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async reverseFunction() {
      this.reverseLoading = true;
      try {
        const response = await ApiService.get(
          `payment/reverse/${this.transactionDetails.transaction_reference}`
        );

        this.reverseLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getTransactionDetails();
      } catch (error) {
        this.reverseLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    async retriggerPayment() {
      this.showUpdateModal = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to Re-Trigger  ${this.transactionDetails.description}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.triggerFunction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
          }
        });
    },
    async updatePaymentStatus() {
      this.showUpdateModal = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to update  ${this.transactionDetails.description} as <span class="text-capitalize fw-bold text-black">${this.statusQuery}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.showUpdateModal = true;
            this.updateStatusFunction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
            this.showUpdateModal = true;
          }
        });
    },
    async updateStatusFunction() {
      try {
        let data = {
          transaction_reference: this.transactionDetails.transaction_reference,
          status: this.statusQuery
        };
        this.statusLoading = true;
        const response = await ApiService.post("payment/update-status", data);

        this.closeModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getTransactionDetails();
      } catch (error) {
        this.closeModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.statusLoading = false;
      }
    },
    async triggerFunction() {
      try {
        this.triggerLoading = true;
        const response = await ApiService.get(
          `payment/retrigger/${this.transactionDetails.transaction_reference}`
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getTransactionDetails();
        this.triggerLoading = false;
      } catch (error) {
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.triggerLoading = false;
      }
    }
  },
  mounted() {
    this.getTransactionDetails();
  }
};
</script>

<style scoped>
.max-width {
  width: max-content;
  padding: 0.4rem 0.6rem;
}

.scroll-h {
  max-height: 300px;
  overflow-y: scroll;
}

.scroll-h::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #c3c2c2;
}

.scroll-h::-webkit-scrollbar {
  width: 3px;
  height: 7px;
}
</style>
